<template>
  <div class="common-label flex items-center gap-spacing_1">
    <p class="label" :class="{ '!text-neutral-500': disabled }">
      {{ label }}
    </p>

    <span
      v-if="required"
      class="astrict"
      :class="{ '!text-neutral-500': disabled }"
    >
      *
    </span>

    <CommonUIcons
      class="icon"
      :name="icon_name"
      :class="{ '!text-neutral-500': disabled }"
    />

    <p
      v-if="optional"
      class="optional"
      :class="{ '!text-neutral-500': disabled }"
    >
      (Optional)
    </p>
  </div>
</template>

<script setup lang="ts">
import type { LabelProps } from "~/types/schemas/common/Atom/label";

defineProps<LabelProps>();
</script>

<style scoped>
.common-label {
  @apply font-secondary text-size_3 font-light text-neutral-800;

  .icon {
    @apply h-icon_size_2 w-icon_size_2;
  }
}
</style>
